const type = 'advanced'
const path = 'server/nodejs/html'
const name = 'server.js'
const fullPath = `${path}/${name}`

const conditions = [
  {
    option: 'frontend',
    value: 'html',
  },
  {
    parameter: 'buttons',
    type: 'not_includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, fullPath, conditions }
